import { bl_fi_mst_entity_vehicle_link_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_link.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleLinkContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_link: bl_fi_mst_entity_vehicle_link_RowClass = new bl_fi_mst_entity_vehicle_link_RowClass();
}
